var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-inline-flex"},[_c('field',{staticClass:"mr-2",attrs:{"label":"","col-class":"col-md-3","params":{
			type: 'select',
			options: _vm.filteredOptions
	}},on:{"change":_vm.categorySelected},model:{value:(_vm.selectedId),callback:function ($$v) {_vm.selectedId=$$v},expression:"selectedId"}}),(_vm.selectedCategory && _vm.selectedCategory.children.length)?_c('material-category-select',{attrs:{"category-tree":_vm.selectedCategory.children},on:{"categorySelected":_vm.returnCategory}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }